import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useFilterState from '../../hooks/useFilterState';
import useRequestsQueryState from '../../hooks/useRequestsQueryState';
import PieCardChart from '../charts/PieCardChart/PieCardChart';
import { ascSort } from '../../helpers/ascSort';

const PieChart = ({
  filter,
  title,
  className,
  style,
  marksChart = false,
  hiddenItem,
  itemKey = 'id',
  renderContent,
  valueKey = 'value',
}) => {
  const [filterState, setFilterState] = useFilterState(filter);
  const [sortItems, setSortItems] = useState([]);

  const items = useSelector(
    (state) => state.statisticsStore.chartsRequests[filter.name]
  );

  const filteredRequests = useSelector(
    (state) => state.statisticsStore.filteredRequests
  );

  const requestsState = useRequestsQueryState();

  const handleItemClick = (entity) => {
    if (filterState.includes(entity[itemKey])) {
      setFilterState((prev) => prev.filter((item) => item !== entity[itemKey]));
    } else {
      setFilterState((prev) => [...prev, entity[itemKey]]);
    }
  };

  const isActiveItem = (item) => filterState.includes(item[itemKey]);

  useEffect(() => {
    let sortItems = [];

    if (items.length) {
      sortItems = ascSort(items.slice(), valueKey);
    }

    setSortItems(sortItems);
  }, [items]);

  return (
    <PieCardChart
      title={title}
      className={className}
      style={style}
      onItemClick={handleItemClick}
      isActiveItem={isActiveItem}
      loading={requestsState?.isFetching}
      data={
        hiddenItem
          ? sortItems.filter((item) => item[itemKey] !== hiddenItem)
          : sortItems
      }
      totalAmountData={filteredRequests.length}
      marksChart={marksChart}
      renderContent={renderContent}
      valueKey={valueKey}
    />
  );
};

export default PieChart;
